// import axios from 'axios'; // removido
import api from '../../api/axiosConfig'; // adicionado

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Table, Tabs } from 'antd';
import { ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import '../Css/AnaliseComponente.css';
import { 
  LineChartOutlined, 
  BarChartOutlined, 
  AreaChartOutlined, 
  BulbOutlined, 
  MenuOutlined 
} from '@ant-design/icons';

const AnalisePrimoCmCC = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [frequeData, setFrequeData] = useState([]);
  const [dezenData, setDezenaData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeKey, setActiveKey] = useState("1");

  // Alerta de carregamento
  useEffect(() => {
    if (loading) {
      Swal.fire({
        title: 'Carregando...',
        text: 'Estamos processando as informações.',
        icon: 'info',
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });
    }
  }, [loading]);

  // Carregar dados da API
  useEffect(() => {
    api.get(`${process.env.REACT_APP_API_URL}/estatistica_atraso_rep_prioCm_cc`)
      .then(response => {
        setData(response.data.data || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));

    api.get(`${process.env.REACT_APP_API_URL}/freque_primoCm_cc`)
      .then(response => {
        setFrequeData(response.data || []);
      })
      .catch(() => setFrequeData([]));

    api.get(`${process.env.REACT_APP_API_URL}/estatistica_atraso_prioCm_cc`)
      .then(response => {
        setDezenaData(response.data.data || []);
      })
      .catch(() => setDezenaData([]));
  }, []);

  // Fechar o alerta depois do carregamento
  useEffect(() => {
    if (!loading) {
      setTimeout(() => {
        Swal.close();
      }, 1500);
    }
  }, [loading]);

  const onTabChange = (key) => setActiveKey(key);

  const columns = [
    { 
      title: 'Primo Cm', 
      key: 'prioCm', 
      render: (text, record) => record.prioCm ?? record.dezenas 
    },
    { title: 'Quantidade', dataIndex: 'qte', key: 'qte' },
    { title: '%', dataIndex: 'percente', key: 'percente', render: (text) => `${text} %` },
    { title: 'Média Sorteio', dataIndex: 'mdSorteio', key: 'mdSorteio' },
    { 
      title: 'Atrasados', 
      dataIndex: 'atrasados', 
      key: 'atrasados',
      render: (text, record) => (
        <span className={record.atrasados > record.mdSorteio ? 'highlight-high' : ''}>{text}</span>
      ) 
    },
    { 
      title: 'Status Jogos', 
      dataIndex: 'pj', 
      key: 'pj',
      render: (text) => {
        let className = '';
        if (text === 'Melhor Opção!') {
          className = 'melhor-opcao';
        } else if (text === 'Atrasados') {
          className = 'highlight-high';
        }
        return <span className={className}>{text}</span>;
      }
    }
  ];

  const frequeColumns = [
    { title: 'Primo Cm', dataIndex: 'dezenas', key: 'dezenas' },
    { title: 'Quantidade', dataIndex: 'qte', key: 'qte' },
    { title: '%', dataIndex: 'percente', key: 'percente', render: (text) => `${text} %` },
    { title: 'Frequência', dataIndex: 'freqAcu', key: 'freqAcu', render: (text) => `${text} - JG` },
    { title: 'Frequência AC', dataIndex: 'freqAcmlda', key: 'freqAcmlda', render: (text) => `${text} %` },
  ];

  const chartData = data.map(item => ({
    name: item.prioCm,
    quantidade: item.qte,
    percentual: item.percente,
  }));

  const frequeChartData = frequeData.map(item => ({
    name: item.dezenas,
    quantidade: item.qte,
    percentual: item.percente,
    frequencia: item.freqAcu,
    frequenciaAc: item.freqAcmlda,
  }));

  const dezenachartData = dezenData.map(item => ({
    name: item.dezenas,
    quantidade: item.qte,
    percentual: item.percente,
  }));

  const tabsItems = [
    {
      label: <LineChartOutlined className="icon-size-24" />,
      key: "1",
      children: (
        <div>
          <h2><span>Análise - Primo Cm CC</span></h2>
          <ResponsiveContainer width="100%" height={400}>
            <ComposedChart data={chartData}>
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="quantidade" barSize={50} fill="#007AA2" />
              <Line type="monotone" dataKey="percentual" stroke="#ff7300" />
            </ComposedChart>
          </ResponsiveContainer>
          <div className="table-container">
            <Table columns={columns} dataSource={data} rowKey="id" pagination />
          </div>
        </div>
      )
    },
    {
      label: <BarChartOutlined className="icon-size-24" />,
      key: "2",
      children: (
        <div>
          <h2><span>Frequência - Primo Cm CC</span></h2>
          <ResponsiveContainer width="100%" height={400}>
            <ComposedChart data={frequeChartData}>
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="quantidade" stackId="a" barSize={50} fill="#004B57" />
              <Bar dataKey="percentual" stackId="a" barSize={50} fill="#ff7300" />
              <Bar dataKey="frequencia" stackId="a" barSize={50} fill="#007AA2" />
              <Bar dataKey="frequenciaAc" stackId="a" barSize={50} fill="#008DC0" />
            </ComposedChart>
          </ResponsiveContainer>
          <div className="table-container">
            <Table columns={frequeColumns} dataSource={frequeData} rowKey="id" pagination />
          </div>
        </div>
      )
    },
    {
      label: <AreaChartOutlined className="icon-size-24" />,
      key: "3",
      children: (
        <div>
          <h2><span>Dezenas - Primo Cm CC</span></h2>
          <ResponsiveContainer width="100%" height={400}>
            <ComposedChart data={dezenachartData}>
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="quantidade" barSize={50} fill="#007AA2" />
              <Line type="monotone" dataKey="percentual" stroke="#ff7300" />
            </ComposedChart>
          </ResponsiveContainer>
          <div className="table-container">
            <Table columns={columns} dataSource={dezenData} rowKey="id" pagination />
          </div>
        </div>
      )
    },
    {
      label: <BulbOutlined className="icon-size-24" />,
      key: "4",
      children: <h2><span>Ideias Dz - Primo Cm CC</span></h2>
    },
    {
      label: <MenuOutlined className="icon-size-24" onClick={() => navigate("/dashboard")} />,
      key: "5",      
    }
  ];

  return (
    <div className="analysis-container">
      <Tabs activeKey={activeKey} onChange={onTabChange} tabPosition={"right"} items={tabsItems} />
    </div>
  );
};

export default AnalisePrimoCmCC;
